import moment from 'moment';
import { convertCelsiusToFahrenheit } from 'shared/helpers/temperature';
import { getLocationDataByDeviceId } from 'shared/helpers/device';
import { getFaultIndexes } from 'features/faults/helpers/faults';

export const getESSAuditTrailFaults = (data, swtStatus) => {
  const faults = [];
  if (!data || !swtStatus) return [];
  data?.forEach(({ row, ...restProps }) => {
    row?.deviceIds?.forEach((deviceId) => {
      if (
        row?.newData?.hasOwnProperty('ssr_fault') &&
        row.newData?.ssr_fault?.includes(1)
      ) {
        faults.push({
          faultType: 'ssr fault',
          number: getFaultIndexes(row.newData?.ssr_fault),
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: row.newData?.position,
          isLCD: row.isLCD,
        });
      }

      if (
        row?.newData?.hasOwnProperty('thermocouple_fault') &&
        row.newData?.thermocouple_fault?.includes(1)
      ) {
        faults.push({
          faultType: 'thermocouple failure',
          number: getFaultIndexes(row.newData?.thermocouple_fault),
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: row.newData?.position,
          isLCD: row.isLCD,
        });
      }
      if (
        row?.newData?.hasOwnProperty('ground_fault') &&
        row.newData?.ground_fault === 1
      ) {
        faults.push({
          faultType: 'ground fault',
          number: [],
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: undefined,
          isLCD: row.isLCD,
        });
      }

      if (
        row?.newData?.hasOwnProperty('srr_over_current') &&
        row.newData?.srr_over_current?.includes(1)
      ) {
        faults.push({
          faultType: 'ssr over current',
          number: getFaultIndexes(row.newData?.srr_over_current),
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: row.newData?.position,
          isLCD: row.isLCD,
        });
      }
    });
  });
  return faults;
};

export const getTESAuditTrailFaults = (data, swtStatus) => {

  const faults = [];
  if (!data || !swtStatus) return [];
  data?.forEach(({ row, ...restProps }) => {
    row?.deviceIds?.forEach((deviceId) => {
        const locationData=  getLocationDataByDeviceId(deviceId, swtStatus);
      let locationid;
      if (locationData?.parent_location_id) {
        locationid = locationData.parent_location_id;
      } else {
        locationid = locationData?.locationId;
      }
      if (
        row?.newData?.hasOwnProperty('e_ssr_fault') &&
        row.newData?.e_ssr_fault?.includes(1)
      ) {
        faults.push({
          faultType: 'ssr fault',
          number: getFaultIndexes(row.newData?.e_ssr_fault),
          locationPre: 'mbta',
          location:locationid,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: row.newData?.position,
          isLCD: row.isLCD,
        });
      }

      if (
        row?.newData?.hasOwnProperty('e_thermocouple_fault') &&
        row.newData?.e_thermocouple_fault?.includes(1)
      ) {
        faults.push({
          faultType: 'thermocouple failure',
          number: getFaultIndexes(row.newData?.e_thermocouple_fault),
          locationPre: 'mbta',
          location: locationid,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: row.newData?.position,
          isLCD: row.isLCD,
        });
      }
      if (
        row?.newData?.hasOwnProperty('e_ground_fault') &&
        row.newData?.e_ground_fault === 1
      ) {
        faults.push({
          faultType: 'ground fault',
          number: [],
          locationPre: 'mbta',
          location: locationid,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: undefined,
          isLCD: row.isLCD,
        });
      }

      if (
        row?.newData?.hasOwnProperty('e_srr_over_current') &&
        row.newData?.e_srr_over_current?.includes(1)
      ) {
        faults.push({
          faultType: 'ssr over current',
          number: getFaultIndexes(row.newData?.e_srr_over_current),
          locationPre: 'mbta',
          location: locationid,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: row.newData?.position,
          isLCD: row.isLCD,
        });
      }
    });
  });
  return faults;
};
export const getTgsAuditTrailFaults = (data, swtStatus) => {
  const faults = [];
  if (!data || !swtStatus) return [];
  data?.forEach(({ row, ...restProps }) => {
    row?.deviceIds?.forEach((deviceId) => {
      if (
        row?.newData?.hasOwnProperty('bms_fault') &&
        row.newData?.bms_fault === 1
      ) {
        faults.push({
          faultType: 'bms fault',
          number: [],
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: undefined,
          isLCD: row.isLCD,
        });
      }

      if (
        row?.newData?.hasOwnProperty('hplp_fault') &&
        row.newData?.hplp_fault === 1
      ) {
        faults.push({
          faultType: 'hp/lp fault',
          number: [],
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: undefined,
          isLCD: row.isLCD,
        });
      }
      if (
        row?.newData?.hasOwnProperty('thermocouple_fault') &&
        row.newData?.thermocouple_fault === 1
      ) {
        faults.push({
          faultType: 'thermocouple fault',
          number: [],
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: undefined,
          isLCD: row.isLCD,
        });
      }

      if (
        row?.newData?.hasOwnProperty('timeout_fault') &&
        row.newData?.timeout_fault === 1
      ) {
        faults.push({
          faultType: 'timeout fault',
          number: [],
          locationPre: 'mbta',
          location: getLocationDataByDeviceId(deviceId, swtStatus)?.locationId,
          machine: deviceId,
          address: getLocationDataByDeviceId(deviceId, swtStatus)
            ?.locationAddress,
          date: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
          attends: row.userAttends,
          position: undefined,
          isLCD: row.isLCD,
        });
      }
    });
  });
  return faults;
};

export const auditTrailActionsDataForamt = (data, swtStatus, isF, allUsers) => {
  if (!data || !swtStatus) return [];
  const unit = isF ? `°F` : `°C`;
  return data?.map(({ row, ...restProps }) => {
    const actionLoctaionIds = [
      ...new Set(
        row.deviceIds?.map(
          (deviceId) =>
            getLocationDataByDeviceId(deviceId, swtStatus)?.locationId
        )||[]
      ),
    ];

    const actionSwitches = {};
    row.deviceIds?.forEach((deviceId) => {
      const locationId = getLocationDataByDeviceId(
        deviceId,
        swtStatus
      )?.locationId;
      if (actionSwitches.hasOwnProperty(locationId)) {
        actionSwitches[locationId].push(deviceId);
      } else {
        actionSwitches[locationId] = [deviceId];
      }
    });
    let userData = allUsers.find((user) => user.user_id === row.userId);

    const defaultData = {
      companyName: 'ATA',
      actionType: row.actionType,
      date: new Date(row.createdAt),
      userName: userData?.username,
      userCode: userData?.user_code,
      system: row.deviceType,
      locations: actionLoctaionIds,
      switches: actionSwitches,
      machines: row.deviceIds,
      isLCD: row.isLCD,
      parameters: {},
    };

    if (
      row?.actionType === 'GLOBAL_TELEMETRY_OVERVIEW' ||
      row?.actionType === 'AUDIT_TRAIL'
    ) {
      return {
        ...defaultData,
        parameters: {
          commandNumber: row.newData?.commandNumber,
          ...(row?.actionType === 'GLOBAL_TELEMETRY_OVERVIEW' && {
            globalTelemetryOverview: row.newData,
          }),
          ...(row?.actionType === 'AUDIT_TRAIL' && {
            auditTrail: {
              startDate: moment(row.newData.startDate).format('h:mma M/D/YYYY'),
              endDate: moment(row.newData.endDate).format('h:mma M/D/YYYY'),
            },
          }),
        },
      };
    }

    if (
      row?.actionType === 'SETTING' ||
      row?.actionType === 'HEAT_CONFIGURATION'
    ) {
      return {
        ...defaultData,
        parameters: {
          commandNumber: row.newData?.commandNumber,
          ...(row.newData.hasOwnProperty('EBP_mode') && {
            EBP_mode: row.newData.EBP_mode,
          }),
          ...(row.newData.hasOwnProperty('e_EBP_mode') && {
            EBP_mode: row.newData.e_EBP_mode,
          }),
          ...(row.newData.hasOwnProperty('TES_enabled') && {
            TES_enabled: row.newData.TES_enabled,
          }),
          ...(row.newData.hasOwnProperty('blower_snow_threshold') && {
            blower_snow_threshold: row.newData.blower_snow_threshold,
          }),
          ...(row.newData.hasOwnProperty('electrical_snow_threshold') && {
            electrical_snow_threshold: row.newData.electrical_snow_threshold,
          }),
          ...(row.newData.hasOwnProperty('blower_temp_ch') && {
            blower_temp_ch: row.newData.blower_temp_ch,
          }),
          ...(row.newData.hasOwnProperty('burner_temp_ch') && {
            burner_temp_ch: row.newData.burner_temp_ch,
          }),
          ...(row.newData.hasOwnProperty('display_temp_ch') && {
            display_temp_ch: row.newData.display_temp_ch,
          }),
          ...(row.newData.hasOwnProperty('enclosure_temp_ch') && {
            enclosure_temp_ch: row.newData.enclosure_temp_ch,
          }),
          ...(row.newData.hasOwnProperty('outside_temp_ch') && {
            outside_temp_ch: row.newData.outside_temp_ch,
          }),
          ...(row.newData.hasOwnProperty('tc_mode') && {
            tc_mode: row.newData.tc_mode,
          }),
          ...(row.newData.hasOwnProperty('wind_threshold') && {
            wind_threshold: row.newData.wind_threshold,
          }),
          ...(row.newData.hasOwnProperty('gas_type') && {
            gas_type: row.newData.gas_type,
          }),
          ...(row.newData.hasOwnProperty('force_run') && {
            force: row.newData.force_run,
          }),
          ...(row.newData.hasOwnProperty('force') && {
            force: row.newData.force,
          }),
          ...(row.newData.hasOwnProperty('initial_open') && {
            initial_open: row.newData.initial_open,
          }),
          ...(row.newData.hasOwnProperty('min_open') && {
            min_open: row.newData.min_open,
          }),
          ...(row.newData.hasOwnProperty('max_open') && {
            max_open: row.newData.max_open,
          }),
        },
      };
    }

    return {
      ...defaultData,
      ...(row.deviceType === 'ESS'
        ? {
            parameters: {
              ...(row.newData.hasOwnProperty('on_switch') && {
                instantHeat: row.newData.on_switch
                  ? `active ${
                      row.newData.hasOwnProperty('instant_temp') &&
                      (isF
                        ? convertCelsiusToFahrenheit(row.newData.instant_temp)
                        : row.newData.instant_temp)
                    }${unit}`
                  : 'off',
              }),
              ...(!row.newData.hasOwnProperty('on_switch') &&
                row.newData.hasOwnProperty('instant_temp') &&
                row.prevData.hasOwnProperty('instant_temp') && {
                  instantHeatChangeTemp: `from ${row.prevData.instant_temp}${unit} to ${row.newData.instant_temp}${unit}`,
                }),
              ...(row.newData.hasOwnProperty('on_constant') && {
                optionalConstantTemp: row.newData.on_constant
                  ? `ready ${
                      row.newData.constant_temp && isF
                        ? convertCelsiusToFahrenheit(row.newData.constant_temp)
                        : row.newData.constant_temp
                    }${unit}`
                  : 'off',
              }),
              ...(!row.newData.hasOwnProperty('on_constant') &&
                row.newData.hasOwnProperty('constant_temp') &&
                row.prevData.hasOwnProperty('constant_temp') && {
                  optionalConstantTempChanged: `from ${row.prevData.constant_temp}${unit} to ${row.newData.constant_temp}${unit}`,
                }),
              ...((row.newData.hasOwnProperty('snow_enabled') ||
                row.newData.hasOwnProperty('snow_trigger')) && {
                snowSensor:
                  row.newData.snow_enabled || row.newData.snow_trigger
                    ? row.newData.snow_enabled
                      ? 'ready'
                      : 'active'
                    : 'off',
              }),
              ...(row.newData.hasOwnProperty('scheduleAdd') && {
                heatingSchedule: row.newData.scheduleAdd?.startDate
                  ? `ready ${
                      isF
                        ? convertCelsiusToFahrenheit(
                            row.newData.scheduleAdd.threshold
                          )
                        : row.newData.scheduleAdd.threshold
                    }${unit}` +
                    ` | ${moment(row.newData.scheduleAdd.startDate).format(
                      'h:mma M/D/YYYY'
                    )}` +
                    ` | ${moment(row.newData.scheduleAdd.endDate).format(
                      'h:mma M/D/YYYY'
                    )}`
                  : 'off',
              }),
              ...(row.prevData.hasOwnProperty('scheduleDelete') && {
                scheduleEnabled: 'off',
              }),
              ...(row.newData.hasOwnProperty('schedule_enabled') && {
                scheduleEnabled:
                  row.newData.schedule_enabled === 1 ? 'enabled' : 'disabled',
              }),
              ...((row.newData.hasOwnProperty('wind_enabled') ||
                row.newData.hasOwnProperty('wind_trigger')) && {
                windFactor:
                  row.newData.wind_enabled || row.newData.wind_trigger
                    ? row.newData.wind_enabled
                      ? 'ready'
                      : 'active'
                    : 'off',
              }),
              ...(row.newData.hasOwnProperty('freeze') && {
                freeze: row.newData.freeze ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('device_active') && {
                deviceActive: row.newData.device_active ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('EBP') && {
                EBP: row.newData.EBP,
              }),
              ...(row?.actionType === 'SSR_RESET' && {
                ssrReset: true,
              }),
              ...(row?.actionType === 'GROUND_RESET' && {
                groundReset: true,
              }),
              ...(row?.actionType === 'THERMOCOUPLE_RESET' &&
                (row.newData.hasOwnProperty('position') ||
                  row.newData.hasOwnProperty('index')) && {
                  thermocoupleReset: true,
                }),
              ...(row?.actionType === 'THERMOCOUPLE_RESET' &&
                row.newData.hasOwnProperty('thermocouple') && {
                  thermocoupleForce: row.newData.thermocouple.fault_mode,
                }),
              ...(row?.actionType === 'GLOBAL_TELEMETRY_OVERVIEW' && {
                globalTelemetryOverview: row.newData,
              }),
              commandNumber: row.newData?.commandNumber,
            },
          }
        : row.deviceType === 'TES'
        ? {
            parameters: {
              ...(row.newData.hasOwnProperty('e_on_switch') && {
                instantHeat: row.newData.e_on_switch
                  ? `active ${
                      row.newData.hasOwnProperty('e_instant_temp') &&
                      (isF
                        ? convertCelsiusToFahrenheit(row.newData.e_instant_temp)
                        : row.newData.e_instant_temp)
                    }${unit}`
                  : 'off',
              }),
              ...(row.newData.hasOwnProperty('on_switch') && {
                instantHeat: row.newData.on_switch
                  ? `active ${
                      row.newData.hasOwnProperty('instant_temp') &&
                      (isF
                        ? convertCelsiusToFahrenheit(row.newData.instant_temp)
                        : row.newData.instant_temp)
                    }${unit}`
                  : 'off',
              }),
              ...(!row.newData.hasOwnProperty('on_switch') &&
                row.newData.hasOwnProperty('e_instant_temp') &&
                row.prevData.hasOwnProperty('e_instant_temp') && {
                  instantHeatChangeTemp: `from ${row.prevData.e_instant_temp}${unit} to ${row.newData.e_instant_temp}${unit}`,
                }),
              ...(row.newData.hasOwnProperty('e_on_constant') && {
                optionalConstantTemp: row.newData.e_on_constant
                  ? `ready ${
                      row.newData.e_constant_temp && isF
                        ? convertCelsiusToFahrenheit(
                            row.newData.e_constant_temp
                          )
                        : row.newData.e_constant_temp
                    }${unit}`
                  : 'off',
              }),
              ...(!row.newData.hasOwnProperty('e_on_constant') &&
                row.newData.hasOwnProperty('e_constant_temp') &&
                row.prevData.hasOwnProperty('e_constant_temp') && {
                  optionalConstantTempChanged: `from ${row.prevData.e_constant_temp}${unit} to ${row.newData.e_constant_temp}${unit}`,
                }),
              ...((row.newData.hasOwnProperty('e_snow_enabled') ||
                row.newData.hasOwnProperty('e_snow_trigger')) && {
                snowSensor:
                  row.newData.e_snow_enabled || row.newData.e_snow_trigger
                    ? row.newData.e_snow_enabled
                      ? 'ready'
                      : 'active'
                    : 'off',
              }),
              ...(row.newData.hasOwnProperty('scheduleAdd') && {
                heatingSchedule: row.newData.scheduleAdd?.startDate
                  ? `ready ${
                      isF
                        ? convertCelsiusToFahrenheit(
                            row.newData.scheduleAdd.threshold
                          )
                        : row.newData.scheduleAdd.threshold
                    }${unit}` +
                    ` | ${moment(row.newData.scheduleAdd.startDate).format(
                      'h:mma M/D/YYYY'
                    )}` +
                    ` | ${moment(row.newData.scheduleAdd.endDate).format(
                      'h:mma M/D/YYYY'
                    )}`
                  : 'off',
              }),
              ...(row.prevData.hasOwnProperty('scheduleDelete') && {
                scheduleEnabled: 'off',
              }),
              ...(row.newData.hasOwnProperty('e_schedule_enabled') && {
                scheduleEnabled:
                  row.newData.e_schedule_enabled === 1 ? 'enabled' : 'disabled',
              }),
              ...((row.newData.hasOwnProperty('e_wind_enabled') ||
                row.newData.hasOwnProperty('e_wind_trigger')) && {
                windFactor:
                  row.newData.e_wind_enabled || row.newData.e_wind_trigger
                    ? row.newData.e_wind_enabled
                      ? 'ready'
                      : 'active'
                    : 'off',
              }),
              ...(row.newData.hasOwnProperty('e_freeze') && {
                freeze: row.newData.e_freeze ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('device_active') && {
                deviceActive: row.newData.device_active ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('EBP') && {
                EBP: row.newData.EBP,
              }),
              ...(row?.actionType === 'SSR_RESET' && {
                ssrReset: true,
              }),
              ...(row?.actionType === 'GROUND_RESET' && {
                groundReset: true,
              }),
              ...(row?.actionType === 'THERMOCOUPLE_RESET' &&
                (row.newData.hasOwnProperty('position') ||
                  row.newData.hasOwnProperty('index')) && {
                  thermocoupleReset: true,
                }),
              ...(row?.actionType === 'THERMOCOUPLE_RESET' &&
                row.newData.hasOwnProperty('thermocouple') && {
                  thermocoupleForce: row.newData.thermocouple.fault_mode,
                }),
              commandNumber: row.newData?.commandNumber,
            },
          }
        : {
            parameters: {
              ...(row.newData.hasOwnProperty('on_switch') && {
                instantHeat: row.newData.on_switch
                  ? `active ${
                      row.newData.instant_temp &&
                      (isF
                        ? convertCelsiusToFahrenheit(row.newData.instant_temp)
                        : row.newData.instant_temp)
                    }${unit}`
                  : 'off',
              }),
              ...(!row.newData.hasOwnProperty('on_switch') &&
                row.newData.hasOwnProperty('instant_temp') &&
                row.prevData.hasOwnProperty('instant_temp') && {
                  instantHeatChangeTemp: `from ${row.prevData.instant_temp}${unit} to ${row.newData.instant_temp}${unit}`,
                }),
              ...((row.newData.hasOwnProperty('snow_enabled') ||
                row.newData.hasOwnProperty('snow_trigger')) && {
                snowSensor:
                  row.newData.snow_enabled || row.newData.snow_trigger
                    ? row.newData.snow_enabled
                      ? 'ready'
                      : 'active'
                    : 'off',
              }),
              ...(row.newData.hasOwnProperty('scheduleAdd') && {
                heatingSchedule: row.newData.scheduleAdd?.startDate
                  ? `ready ${
                      isF
                        ? convertCelsiusToFahrenheit(
                            row.newData.scheduleAdd.threshold
                          )
                        : row.newData.scheduleAdd.threshold
                    }${unit}` +
                    ` | ${moment(row.newData.scheduleAdd.startDate).format(
                      'h:mma M/D/YYYY'
                    )}` +
                    ` | ${moment(row.newData.scheduleAdd.endDate).format(
                      'h:mma M/D/YYYY'
                    )}`
                  : 'off',
              }),
              ...(row.prevData.hasOwnProperty('scheduleDelete') && {
                scheduleEnabled: 'off',
              }),
              ...(row.newData.hasOwnProperty('schedule_enabled') && {
                scheduleEnabled:
                  row.newData.schedule_enabled === 1 ? 'enabled' : 'disabled',
              }),
              ...((row.newData.hasOwnProperty('wind_enabled') ||
                row.newData.hasOwnProperty('wind_trigger')) && {
                windFactor:
                  row.newData.wind_enabled || row.newData.wind_trigger
                    ? row.newData.wind_enabled
                      ? 'ready'
                      : 'active'
                    : 'off',
              }),
              ...(row.newData.hasOwnProperty('freeze') && {
                freeze: row.newData.freeze ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('device_active') && {
                deviceActive: row.newData.device_active ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('fan') && {
                fan: row.newData.fan ? 'on' : 'off',
              }),
              ...(row.newData.hasOwnProperty('EBP') && {
                EBP: row.newData.EBP,
              }),
              ...(row?.actionType === 'SSR_RESET' && {
                ssrReset: true,
              }),
              ...(row?.actionType === 'GROUND_RESET' && {
                groundReset: true,
              }),
              ...(row?.actionType === 'HPLP_RESET' && {
                Hp_LpReset: true,
              }),
              ...(row?.actionType === 'TIMEOUT_RESET' && {
                timeOutReset: true,
              }),
              ...(row?.actionType === 'THERMOCOUPLE_RESET' &&
                (row.newData.hasOwnProperty('position') ||
                  row.newData.hasOwnProperty('index')) && {
                  thermocoupleReset: true,
                }),
              ...(row?.actionType === 'THERMOCOUPLE_RESET' &&
                row.newData.hasOwnProperty('thermocouple') && {
                  thermocoupleForce: row.newData.thermocouple.fault_mode,
                }),
              commandNumber: row.newData?.commandNumber,
            },
          }),
    };
  });
};

export const auditTrailSettingsDataForamt = (data) => {
  if (!data || !Array.isArray(data) || data.length === 0) return [];

  const sortedData = data.sort((a, b) => a.row.userId - b.row.userId);

  const userLoginLogs = [];

  for (let i = 0; i < sortedData.length; i++) {
    const currentRow = sortedData[i].row;
    const logObj = { login: null, logout: null };

    if (currentRow?.newData.login === true) {
      if (
        i < sortedData.length - 1 &&
        sortedData[i + 1].row.newData.login === false
      ) {
        logObj.login = new Date(currentRow.createdAt);
        logObj.logout = new Date(sortedData[i + 1].row.createdAt);
        i++;
      } else {
        logObj.login = new Date(currentRow.createdAt);
      }
    } else if (currentRow?.newData.login === false) {
      if (i > 0 && sortedData[i - 1]?.row.newData.login === true) {
        logObj.login = new Date(sortedData[i - 1].row.createdAt);
        logObj.logout = new Date(currentRow.createdAt);
      } else {
        logObj.logout = new Date(currentRow.createdAt);
      }
    }

    userLoginLogs.push(logObj);
  }

  return userLoginLogs;
};

export const getAuditTrailActionTitle = (
  actionType,
  deviceType,
  isLCD = null
) => {
  const actionTypeTitles = {
    MASTER_CONTROL: {
      ESS: 'ESS-MASTER CONTROL ACTION',
      TES: 'TES-MASTER CONTROL ACTION',
      default: 'TGS-MASTER CONTROL ACTION',
    },
    GLOBAL_MASTER_CONTROL: 'MASTER CONTROL ACTION',
    FAST_MASTER_CONTROL: {
      ESS: 'ESS-QUICK MASTER CONTROL ACTION',
      TES: 'TES-QUICK MASTER CONTROL ACTION',
      default: 'TGS-QUICK MASTER CONTROL ACTION',
    },
    LOCAL_MASTER_CONTROL: {
      ESS: 'ESS-LOCATION CONTROL ACTION',
      TES: 'TES-LOCATION CONTROL ACTION',
      default: 'TGS-LOCATION CONTROL ACTION',
    },

    SSR_RESET: isLCD ? 'SSR FAULT LCD ACTION' : 'SSR FAULT ACTION',
    THERMOCOUPLE_RESET: isLCD
      ? 'THERMOCOUPLE FAILURE LCD ACTION'
      : 'THERMOCOUPLE FAILURE ACTION',
    GROUND_RESET: isLCD ? 'GROUND FAULT ACTION' : 'GROUND FAULT LCD ACTION',
    TIMEOUT_RESET: isLCD
      ? 'TIME OUT FAULT LCD ACTION'
      : 'TIME OUT FAULT ACTION',
    HPLP_RESET: isLCD
      ? 'HIGH PRESSURE/LOW PRESSURE FAULT LCD ACTION'
      : 'HIGH PRESSURE/LOW PRESSURE FAULT ACTION',
    GLOBAL_TELEMETRY_OVERVIEW: 'GLOBAL SYSTEM TELEMETRY OVERVIEW ACTION',
    GLOBAL_DATA_TELEMETRY_OVERVIEW: 'GLOBAL SYSTEM TELEMETRY OVERVIEW ACTION',
    AUDIT_TRAIL: 'AUDIT TRAIL ACTION',
    ACTION: {
      ESS: isLCD ? 'ESS-LCD CONTROL ACTION' : 'ESS-SWITCH CONTROL ACTION',
      TES: isLCD ? 'TES-LCD CONTROL ACTION' : 'TES-SWITCH CONTROL ACTION',
      default: isLCD ? 'TGS-LCD CONTROL ACTION' : 'TGS-SWITCH CONTROL ACTION',
    },
    SETTING: 'SETTINGS ACTION',
    HEAT_CONFIGURATION: 'SETTINGS HEAT LOAD CONFIGURATION ACTION',
  };

  const actionTitle = actionTypeTitles[actionType] || '';

  if (typeof actionTitle === 'string') {
    return actionTitle;
  } else if (typeof actionTitle === 'object') {
    return actionTitle[deviceType] || actionTitle.default || '';
  }

  return '';
};

export const createCommandTitle = (
  actionType = '',
  deviceType = '',
  isLCD = null
) => {
  const actionTypeTitles = {
    MASTER_CONTROL: {
      ESS: 'ESS-MC/A',
      TES: 'TES-MC/A',
      default: 'TGS-MC/A',
    },
    GLOBAL_MASTER_CONTROL: 'MC/A',
    FAST_MASTER_CONTROL: {
      ESS: 'ESS-QUICK/MC/A',
      TES: 'TES-QUICK/MC/A',
      default: 'TGS-QUICK/MC/A',
    },
    LOCAL_MASTER_CONTROL: {
      ESS: 'ESS-LOC_MC/A',
      TES: 'TES-LOC_MC/A',
      default: 'TGS-LOC_MC/A',
    },
    SSR_RESET: isLCD ? 'SSR_F/A' : 'SSR_F/LCD/A',
    THERMOCOUPLE_RESET: isLCD ? 'T/C_F/LCD/A' : 'T/C_F/A',
    GROUND_RESET: isLCD ? 'GROUND_F/LCD/A' : 'GROUND_F/A',
    TIMEOUT_RESET: isLCD ? 'T_O_F/LCD/A' : 'T_O_F/A',
    HPLP_RESET: isLCD ? 'HP/LP_F/LCD/A' : 'HP/LP_F/A',
    GLOBAL_TELEMETRY_OVERVIEW: 'GSTO/A',
    GLOBAL_DATA_TELEMETRY_OVERVIEW: 'GSTO_DATA/A',
    AUDIT_TRAIL: 'AT/A',
    ACTION: {
      ESS: 'ESS-SWT_C/A',
      TES: 'TES-SWT_C/A',
      default: 'TGS-SWT_C/A',
    },
    SETTING: 'SET/A',
    HEAT_CONFIGURATION: 'SET/A',
  };

  const actionTitle = actionTypeTitles[actionType] || '';

  if (typeof actionTitle === 'string') {
    return actionTitle;
  } else if (typeof actionTitle === 'object') {
    return actionTitle[deviceType] || actionTitle.default || '';
  }

  return '';
};

export const machineAuditTrailActionsFormat = (
  actionsArray,
  allUsersArray,
  isF
) => {
  if (!actionsArray) return [];
  const unit = isF ? `°F` : `°C`;
  return actionsArray?.map(({ row, ...restProps }) => {
    let userData = allUsersArray.find((user) => user?.user_id === row?.userId);
    let number = row.newData?.commandNumber ?? 0;
    let commandNumber = `${createCommandTitle(
      row?.actionType,
      row?.deviceType,
      row?.isLCD
    )}-${userData.user_code}-${moment(row.createdAt).format('DDMMYY')}-${
      number < 10 ? `${'0' + number} ` : number
    }`;
    return {
      id: commandNumber,
      userName: userData?.username,
      time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
      parameters: {
        instantHeat: row.newData.on_switch
          ? `active ${
              isF
                ? convertCelsiusToFahrenheit(row.newData.instant_temp)
                : row.newData.instant_temp
            }${unit}`
          : null,
        fanOnly: row.newData.fan ? 'ready' : null,
        optionalConstantTemp: row.newData.on_constant
          ? `ready ${
              isF
                ? convertCelsiusToFahrenheit(row.newData.constant_temp)
                : row.newData.constant_temp
            }${unit}`
          : null,
        snowSensor: row.newData.snow_enabled ? 'ready' : null,
        heatingSchedule: row.newData.schedule?.startDate
          ? `ready ${
              isF
                ? convertCelsiusToFahrenheit(row.newData.schedule.threshold)
                : row.newData.schedule.threshold
            }${unit}` +
            `|${row.newData.schedule.startDate}` +
            `|${row.newData.schedule.endDate}`
          : null,
        windFactor: row.newData.wind ? 'ready' : null,
      },
    };
  });
};

export const machineAuditTrailFaultsFormat = (faultsArray, allUsersArray) => {
  const Formatedfaults = [];
  if (!faultsArray || !allUsersArray) return [];
  faultsArray?.forEach(({ row, ...restProps }) => {
    row?.deviceIds?.forEach((deviceId) => {
      const userData = allUsersArray.find(
        (user) => user?.user_id === row?.userId
      );
      const userName = userData?.username;
      const userTitle = userData?.user_role;
      if (
        row?.newData?.hasOwnProperty('e_ssr_fault') &&
        row.newData?.e_ssr_fault?.includes(1)
      ) {
        Formatedfaults.push({
          fault: 'ssr fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('e_thermocouple_fault') &&
        row.newData?.e_thermocouple_fault?.includes(1)
      ) {
        Formatedfaults.push({
          fault: 'thermocouple fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }
      if (
        row?.newData?.hasOwnProperty('e_ground_fault') &&
        row.newData?.e_ground_fault === 1
      ) {
        Formatedfaults.push({
          fault: 'ground fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('e_srr_over_current') &&
        row.newData?.e_srr_over_current?.includes(1)
      ) {
        Formatedfaults.push({
          fault: 'ssr over current',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('ssr_fault') &&
        row.newData?.ssr_fault?.includes(1)
      ) {
        Formatedfaults.push({
          fault: 'ssr fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('thermocouple_fault') &&
        row.newData?.thermocouple_fault?.includes(1)
      ) {
        Formatedfaults.push({
          fault: 'thermocouple failure',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }
      if (
        row?.newData?.hasOwnProperty('ground_fault') &&
        row.newData?.ground_fault === 1
      ) {
        Formatedfaults.push({
          fault: 'ground fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('srr_over_current') &&
        row.newData?.srr_over_current?.includes(1)
      ) {
        Formatedfaults.push({
          fault: 'ssr over current',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('bms_fault') &&
        row.newData?.bms_fault === 1
      ) {
        Formatedfaults.push({
          fault: 'bms fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('hplp_fault') &&
        row.newData?.hplp_fault === 1
      ) {
        Formatedfaults.push({
          fault: 'hp/lp fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }
      if (
        row?.newData?.hasOwnProperty('thermocouple_fault') &&
        row.newData?.thermocouple_fault === 1
      ) {
        Formatedfaults.push({
          fault: 'thermocouple fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }

      if (
        row?.newData?.hasOwnProperty('timeout_fault') &&
        row.newData?.timeout_fault === 1
      ) {
        Formatedfaults.push({
          fault: 'timeout fault',
          userName: userName,
          title: userTitle,
          comment: [''],
          time: moment(row.createdAt).format('h:mma - DD/MM/YYYY'),
        });
      }
    });
  });
  return Formatedfaults;
};
